<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.11111 3.36364H2V12H10.6667V7M5.33333 8.81818L12 2M12 2V5.18182M12 2H8.88889" stroke="black"/>
<path d="M12 5.18182V2H8.88892" stroke="black"/>
</svg>
